import { useCallback, useSyncExternalStore } from 'react';
import type { IAdvancedCondition } from './IAdvancedCondition';
import { advancedKey, conditionsStore } from './advancedStore';

/**
 * Умови розширених фільтрів типу запису у воркспейсі (усі рядки, разом із неповними) і їх зміна: спільні для всіх пунктів меню й подань
 * модуля (таблиця, картки, дошка, сторінки аналітики), як у прототипі v4; зберігаються в localStorage.
 */
export function useAdvancedFilter(ws: string, rt: string): [IAdvancedCondition[], (next: IAdvancedCondition[]) => void] {
  const key = advancedKey(ws, rt);
  const conditions = useSyncExternalStore(conditionsStore.subscribe, () => conditionsStore.read(key), () => conditionsStore.read(key));
  const set = useCallback((next: IAdvancedCondition[]) => conditionsStore.write(key, next.length ? next : null), [key]);
  return [conditions, set];
}
